<template>
    <div id="queryRecord" class="background-ash pl20 pr20 pb20">
        <!--搜索条件-->
        <div class="search_list background-white">
		   <ul class="lists">
                <li>
                    <span>商品ID</span>
                    <el-input size="small" @keyup.native.enter="searchGetDataList" class="width180" v-model="getDataParam.productId" placeholder="请输入商品ID"></el-input>
                </li>
                <li>
                    <span>商品名称</span>
                    <el-input size="small" @keyup.native.enter="searchGetDataList" class="width180" v-model="getDataParam.productNameLike" placeholder="请输入商品名称"></el-input>
                </li>
				<li>
                    <span>查询时间</span>
                    <el-date-picker  size="small" v-model="time1" type="daterange"  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </li>
				<li>
                    <span>是否收藏</span>
                    <el-select size="small" class="select width100" collapse-tags v-model="getDataParam.isFollow" >
                        <el-option label="全部" value="all"></el-option>
                        <el-option label="是" value="T"></el-option>
                        <el-option label="否" value="F"></el-option>
                    </el-select>
                </li>
                <li>
                    <span>地区</span>
                    <el-input size="small" class="width180" v-model="getDataParam.regionLike" placeholder="请输入地区"></el-input>
                </li>
                <li>
                    <span>平台</span>
                    <el-select size="small" class="select width100" collapse-tags v-model="getDataParam.platformCode" >
                        <el-option label="全部" value="all"></el-option>
                        <el-option v-for="item in platformList" :key="item.platformCode" :value="item.platformCode" :label="item.platformName"></el-option>
                    </el-select>
                </li>
                <li>
                    <span>账号</span>
                    <el-input size="small" class="width180" v-model="getDataParam.mobileLike" placeholder="请输入账号"></el-input>
                </li>
            </ul>
			<div class="btns">
                <el-button size="small" type="primary"  @click="searchGetDataList">搜索</el-button>
            </div>
	   </div>
       <!--内容-->
       <div class="pt20 content">
           <!-- 表头操作 -->
           <div class="watchBar">
               <div class="left color-blue">
                   <span>共计商品{{totalDetail.total||0}}条&emsp;&emsp;&emsp;</span>
                   <span>查询后收藏的有{{totalDetail.followTotal||0}}条&emsp;&emsp;&emsp;</span>
                   <span>未收藏的有{{totalDetail.unFollowTotal||0}}条&emsp;&emsp;&emsp;</span>
                   <span>共计账号{{totalDetail.accountTotal||0}}个&emsp;&emsp;&emsp;</span>
                   <span>游客查询条数{{totalDetail.visitorTotal||0}}条</span>
                </div>
                <div class="btns right">
                    <el-button size="small" class="export-right" type="primary" plain @click="getExport">导出</el-button>
                </div>
            </div>
            <div class="tab">
                <el-table ref="checkList"  size="mini" :data="dataList" tooltip-effect="dark" height="100%">
                   <el-table-column type="index" label="序号"></el-table-column>
                   <el-table-column label="查询账号" prop="account"></el-table-column>
                   <el-table-column label="企业名称" prop="companyName"></el-table-column>
                   <el-table-column label="商品ID">
                        <template slot-scope="scope">{{ scope.row.productId || '' }}</template>
                    </el-table-column>
                    <el-table-column label="商品名称" prop="name"></el-table-column>
                    <el-table-column label="厂家" prop="manufactur"></el-table-column>
                    <el-table-column label="规格" prop="specifications"></el-table-column>
                    <el-table-column label="批准文号" prop="licenseNumber"></el-table-column>
                    <el-table-column label="查询时间" prop="gmtQuery"></el-table-column>
                    <el-table-column label="地区" prop="region"></el-table-column>
                    <el-table-column label="平台" prop="platformName"></el-table-column>
                    <el-table-column label="商家" prop="store"></el-table-column>
                    <el-table-column label="平均价" prop="averagePrice"></el-table-column>
                    <el-table-column label="最低价" prop="lowerPrice"></el-table-column>
                    <el-table-column label="计划采购数量" prop="planQuantity"></el-table-column>
                    <el-table-column label="计划采购价" prop="planPrice"></el-table-column>
                    <el-table-column label="链接">
                        <template slot-scope="scope">
                            <span style="cursor:pointer;"  @click="copyFunc(scope.row.id, scope.row.url)">复制</span>
                            <input class="copy-content" type="text" :value="scope.row.url" :id="scope.row.id"/>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否收藏">
                        <template slot-scope="scope">
                            {{scope.row.isFollow === 'T' ? '是' : '否'}}
                        </template>
                    </el-table-column>
               </el-table>
            </div>
            <div class="page background-white text-right p20">
                <el-pagination @size-change="changePageSize" @current-change="getDataList" :current-page.sync="getDataParam.page"
                :page-sizes="[10, 20, 50, 100]" :page-size="getDataParam.size" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                </el-pagination>
            </div>
       </div>
    </div>
</template>

<script>
export default {
	name: 'queryRecord', //数据分析-查询记录
	data () {
		return {
            id: 0,
			getDataParam: {
                geGmtQuery: '', //查询开始时间
                leGmtQuery:'', //查询结束时间
                regionLike: '',
                productId: null,
                productNameLike: '',
                isFollow: 'all', //T是   F 否
                page:1,
                size:10,
                platformCode: 'all',
                mobileLike: ""
            },
            platformList: [],
            totalDetail: {},
            dataList: [],
            time1: '',
            totalCount: 0
		}
	},
	watch: {
	},
	methods: {
        //分页数据统计
        getTotalDetail () {
            if (!!this.time1 && this.time1.length > 0) {
                this.getDataParam.geGmtQuery = this.$root.format(this.time1[0]);
                this.getDataParam.leGmtQuery = this.$root.format(this.time1[1]);
            } else {
                this.getDataParam.geGmtQuery = "";
                this.getDataParam.leGmtQuery = "";
            }
            let param = {...this.getDataParam};
            if (param.isFollow === 'all') {
                param.isFollow = null;
            }
            if (param.platformCode === 'all') {
                param.platformCode = null;
            }
            this.$http('POST', '/admin/data/count', {}, param, (status, res) => {
                if (status) {
                   if(!!res.data) {
                       this.totalDetail = res.data;
                   }
                }
            })
        },
		getDataList () {
            if (!!this.time1 && this.time1.length > 0) {
                this.getDataParam.geGmtQuery = this.$root.format(this.time1[0]);
                this.getDataParam.leGmtQuery = this.$root.format(this.time1[1]);
            } else {
                this.getDataParam.geGmtQuery = "";
                this.getDataParam.leGmtQuery = "";
            }
            let param = {...this.getDataParam};
            if (param.isFollow === 'all') {
                param.isFollow = null;
            }
            if (param.platformCode === 'all') {
                param.platformCode = null;
            }
            param.page = (param.page-1);
            this.$http('POST', '/admin/data/page', {}, param, (status, res) => {
                if (status) {
                   if(!!res.content && res.content.length > 0) {
                       this.dataList = res.content;
                   }else {
                       this.dataList = [];
                   }
                   this.totalCount = res.totalCount;
                   this.getTotalDetail();
                }
            })
        },
        searchGetDataList () {
            this.getDataParam.page = 1;
            this.getDataList();
        },
        changePageSize (val) {
            this.getDataParam.size = val;
            this.getDataParam.page = 1;
            this.getDataList();
        },
        getExport () {
            if (!!this.time1 && this.time1.length > 0) {
                this.getDataParam.geGmtQuery = this.$root.format(this.time1[0]);
                this.getDataParam.leGmtQuery = this.$root.format(this.time1[1]);
            } else {
                this.getDataParam.geGmtQuery = "";
                this.getDataParam.leGmtQuery = "";
            }
            let param = {...this.getDataParam};
            if (param.isFollow === 'all') {
                param.isFollow = null;
            }
            if (param.platformCode === 'all') {
                param.platformCode = null;
            }
            const loading = this.load();
            this.$http('POST', '/admin/data/export', {}, param, (status, res) => {
                loading.close();
                if (status) {
                   if (res.status === '200') {
                       this.educe(res.data);
                   }
                }
            })
        },
        copyFunc (id, val) {
            let input = document.createElement('input')
            input.value = val//this.url+'/'+this.params.code;
            document.body.appendChild(input);
            input.select();
            document.execCommand('Copy');
            this.success('复制成功');
            input.remove();
            // let input = document.getElementById(id);
            // input.select();
            // console.log('val.....',val);
            // document.execCommand('Copy', false);
            // this.success('复制成功')
        },
        getAllPlatform () {
            this.$http('POST', '/admin/platform/all', {}, {}, (status, res) => {
                if (status) {
                   if (res.data && res.data.length > 0) {
                       this.platformList = res.data;
                   } else {
                       this.platformList = [];
                   }
                   this.getDataList();
                }
            })
        }
	},
	mounted () {
        this.getAllPlatform();
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#queryRecord {width: 100%;height: calc(100vh - 132px);}
#queryRecord .content {height: calc(100% - 76px);}
#queryRecord .content .tab {height: calc(100% - 125px);}
#queryRecord >>>.el-table th.type>.cell, #queryRecord >>>.el-table td.type>.cell {margin-left: 75px;}
#queryRecord .copy-content{width: 5px; height: 5px; opacity: 0;}
</style>



// WEBPACK FOOTER //
// src/views/dataAnalysis/queryRecord.vue